import { IAppLazyWidget } from 'core-components/sitebuilder/models/IWidgetSelector'

export const lazyWidgets: IAppLazyWidget[] = [
  {
    key: 'KbaseWidgetSelector',
    loader: () => import('remoteKbase/WidgetSelector'),
  },
  {
    key: 'DocflowWidgetSelector',
    loader: () => import('remoteDocflow/WidgetSelector'),
  },
]
